<template>
	<div
		class="flex flex-col rounded-2xl shadow bg-surface p-4 gap-4 overflow-hidden"
	>
		<div class="title text-jca-dark-blue flex items-center gap-2">
			<slot name="title" />
		</div>
		<div class="body-1"><slot /></div>
		<div class="flex gap-2 justify-end">
			<slot name="actions" />
		</div>
	</div>
</template>
